// xiaole
export const encodeMapping = [
  {
    'en': 'smile',
    'char': '/::)',
    'cn': '微笑'
  },
  {
    'en': 'grimance',
    'char': '/::~',
    'cn': '撇嘴'
  },
  {
    'en': 'drool',
    'char': '/::B',
    'cn': '色'
  },
  {
    'en': 'scowl',
    'char': '/::|',
    'cn': '发呆'
  },
  {
    'en': 'cool_guy',
    'char': '/:8-)',
    'cn': '得意'
  },
  {
    'en': 'sob',
    'char': '/::<',
    'cn': '流泪'
  },
  {
    'en': 'shy',
    'char': '/::$',
    'cn': '害羞'
  },
  {
    'en': 'silent',
    'char': '/::X',
    'cn': '闭嘴'
  },
  {
    'en': 'sleep',
    'char': '/::Z',
    'cn': '睡'
  },
  {
    'en': 'cry',
    'char': '/::\'(',
    'cn': '大哭'
  },
  {
    'en': 'awkward',
    'char': '/::-|',
    'cn': '尴尬'
  },
  {
    'en': 'angry',
    'char': '/::@',
    'cn': '发怒'
  },
  {
    'en': 'tongue',
    'char': '/::P',
    'cn': '调皮'
  },
  {
    'en': 'grin',
    'char': '/::D',
    'cn': '呲牙'
  },
  {
    'en': 'surprise',
    'char': '/::O',
    'cn': '惊讶'
  },
  {
    'en': 'frown',
    'char': '/::(',
    'cn': '难过'
  },
  {
    'en': 'ruthless',
    'char': '/::+',
    'cn': '酷'
  },
  {
    'en': 'blush',
    'char': '/:--b',
    'cn': '囧'
  },
  {
    'en': 'scream',
    'char': '/::Q',
    'cn': '抓狂'
  },
  {
    'en': 'puke',
    'char': '/::T',
    'cn': '吐'
  },
  {
    'en': 'chuckle',
    'char': '/:,@P',
    'cn': '偷笑'
  },
  {
    'en': 'joyful',
    'char': '/:,@-D',
    'cn': '愉快'
  },
  {
    'en': 'slight',
    'char': '/::d',
    'cn': '白眼'
  },
  {
    'en': 'smug',
    'char': '/:,@o',
    'cn': '傲慢'
  },
  {
    'en': 'hungry',
    'char': '/::g',
    'cn': '饥饿'
  },
  {
    'en': 'drowsy',
    'char': '/:|-)',
    'cn': '困'
  },
  {
    'en': 'panic',
    'char': '/::!',
    'cn': '惊恐'
  },
  {
    'en': 'sweat',
    'char': '/::L',
    'cn': '流汗'
  },
  {
    'en': 'laugh',
    'char': '/::>',
    'cn': '憨笑'
  },
  {
    'en': 'commando',
    'char': '/::,@',
    'cn': '悠闲'
  },
  {
    'en': 'determined',
    'char': '/:,@f',
    'cn': '奋斗'
  },
  {
    'en': 'scold',
    'char': '/::-S',
    'cn': '咒骂'
  },
  {
    'en': 'shocked',
    'char': '/:?',
    'cn': '疑问'
  },
  {
    'en': 'shhh',
    'char': '/:,@x',
    'cn': '嘘'
  },
  {
    'en': 'dizzy',
    'char': '/:,@@',
    'cn': '晕'
  },
  {
    'en': 'tormented',
    'char': '/::8',
    'cn': '疯了'
  },
  {
    'en': 'toasted',
    'char': '/:,@!',
    'cn': '衰'
  },
  {
    'en': 'skull',
    'char': '/:!!!',
    'cn': '骷髅'
  },
  {
    'en': 'hammer',
    'char': '/:xx',
    'cn': '敲打'
  },
  {
    'en': 'wave',
    'char': '/:bye',
    'cn': '再见'
  },
  {
    'en': 'speechless',
    'char': '/:wipe',
    'cn': '擦汗'
  },
  {
    'en': 'nose_pick',
    'char': '/:dig',
    'cn': '抠鼻'
  },
  {
    'en': 'clap',
    'char': '/:handclap',
    'cn': '鼓掌'
  },
  {
    'en': 'shame',
    'char': '/:&-(',
    'cn': '糗大了'
  },
  {
    'en': 'trick',
    'char': '/:B-)',
    'cn': '坏笑'
  },
  {
    'en': 'bah_l',
    'char': '/:<@',
    'cn': '左哼哼'
  },
  {
    'en': 'bah_r',
    'char': '/:@>',
    'cn': '右哼哼'
  },
  {
    'en': 'yawn',
    'char': '/::-O',
    'cn': '哈欠'
  },
  {
    'en': 'pooh_pooh',
    'char': '/:>-|',
    'cn': '鄙视'
  },
  {
    'en': 'shrunken',
    'char': '/:P-(',
    'cn': '委屈'
  },
  {
    'en': 'tearing_up',
    'char': '/::\'|',
    'cn': '快哭了'
  },
  {
    'en': 'sly',
    'char': '/:X-)',
    'cn': '阴险'
  },
  {
    'en': 'kiss',
    'char': '/::*',
    'cn': '亲亲'
  },
  {
    'en': 'wrath',
    'char': '/:@x',
    'cn': '吓'
  },
  {
    'en': 'whimper',
    'char': '/:8*',
    'cn': '可怜'
  },
  {
    'en': 'cleaver',
    'char': '/:pd',
    'cn': '菜刀'
  },
  {
    'en': 'watermelon',
    'char': '/:<W>',
    'cn': '西瓜'
  },
  {
    'en': 'beer',
    'char': '/:beer',
    'cn': '啤酒'
  },
  {
    'en': 'basketball',
    'char': '/:basketb',
    'cn': '篮球'
  },
  {
    'en': 'ping_pong',
    'char': '/:oo',
    'cn': '乒乓'
  },
  {
    'en': 'coffee',
    'char': '/:coffee',
    'cn': '咖啡'
  },
  {
    'en': 'rice',
    'char': '/:eat',
    'cn': '饭'
  },
  {
    'en': 'pig',
    'char': '/:pig',
    'cn': '猪头'
  },
  {
    'en': 'rose',
    'char': '/:rose',
    'cn': '玫瑰'
  },
  {
    'en': 'wilt',
    'char': '/:fade',
    'cn': '凋谢'
  },
  {
    'en': 'lips',
    'char': '/:showlove',
    'cn': '嘴唇'
  },
  {
    'en': 'heart',
    'char': '/:heart',
    'cn': '爱心'
  },
  {
    'en': 'broken_heart',
    'char': '/:break',
    'cn': '心碎'
  },
  {
    'en': 'cake',
    'char': '/:cake',
    'cn': '蛋糕'
  },
  {
    'en': 'lightning',
    'char': '/:li',
    'cn': '闪电'
  },
  {
    'en': 'bomb',
    'char': '/:bome',
    'cn': '炸弹'
  },
  {
    'en': 'dagger',
    'char': '/:kn',
    'cn': '刀'
  },
  {
    'en': 'soccer',
    'char': '/:footb',
    'cn': '足球'
  },
  {
    'en': 'ladybug',
    'char': '/:ladybug',
    'cn': '瓢虫'
  },
  {
    'en': 'poop',
    'char': '/:shit',
    'cn': '便便'
  },
  {
    'en': 'moon',
    'char': '/:moon',
    'cn': '月亮'
  },
  {
    'en': 'sun',
    'char': '/:sun',
    'cn': '太阳'
  },
  {
    'en': 'gift',
    'char': '/:gift',
    'cn': '礼物'
  },
  {
    'en': 'hug',
    'char': '/:hug',
    'cn': '拥抱'
  },
  {
    'en': 'thumbs_up',
    'char': '/:strong',
    'cn': '强'
  },
  {
    'en': 'thumbs_down',
    'char': '/:weak',
    'cn': '弱'
  },
  {
    'en': 'shake',
    'char': '/:share',
    'cn': '握手'
  },
  {
    'en': 'peace',
    'char': '/:v',
    'cn': '胜利'
  },
  {
    'en': 'fight',
    'char': '/:@)',
    'cn': '抱拳'
  },
  {
    'en': 'beckon',
    'char': '/:jj',
    'cn': '勾引'
  },
  {
    'en': 'fist',
    'char': '/:@@',
    'cn': '拳头'
  },
  {
    'en': 'pinky',
    'char': '/:bad',
    'cn': '差劲'
  },
  {
    'en': 'rock_on',
    'char': '/:lvu',
    'cn': '爱你'
  },
  {
    'en': 'nuh_uh',
    'char': '/:no',
    'cn': 'NO'
  },
  {
    'en': 'ok',
    'char': '/:ok',
    'cn': 'OK'
  },
  {
    'en': 'in_love',
    'char': '/:love',
    'cn': '爱情'
  },
  {
    'en': 'blowkiss',
    'char': '/:<L>',
    'cn': '飞吻'
  },
  {
    'en': 'waddle',
    'char': '/:jump',
    'cn': '跳跳'
  },
  {
    'en': 'tremble',
    'char': '/:shake',
    'cn': '发抖'
  },
  {
    'en': 'aaagh',
    'char': '/:<O>',
    'cn': '怄火'
  },
  {
    'en': 'twirl',
    'char': '/:circle',
    'cn': '转圈'
  },
  {
    'en': 'kotow',
    'char': '/:kotow',
    'cn': '磕头'
  },
  {
    'en': 'dramatic',
    'char': '/:turn',
    'cn': '回头'
  },
  {
    'en': 'jump_rope',
    'char': '/:skip',
    'cn': '跳绳'
  },
  {
    'en': 'surrender',
    'char': '/:oY',
    'cn': '投降'
  },
  {
    'en': 'hooray',
    'char': '',
    'cn': '激动'
  },
  {
    'en': 'meditate',
    'char': '',
    'cn': '乱舞'
  },
  {
    'en': 'smooch',
    'char': '',
    'cn': '献吻'
  },
  {
    'en': 'taichi_l',
    'char': '',
    'cn': '左太极'
  },
  {
    'en': 'taichi_r',
    'char': '',
    'cn': '右太极'
  }
]
// 定制化zhilian
export const encodeMappingDev = [

  {
    'en': 'smile',
    'char': '/::)',
    'cn': '微笑'
  },
  {
    'en': 'grimance',
    'char': '/::~',
    'cn': '撇嘴'
  },
  {
    'en': 'drool',
    'char': '/::B',
    'cn': '色'
  },
  {
    'en': 'scowl',
    'char': '/::|',
    'cn': '发呆'
  },
  // {
  //   'en': 'cool_guy',
  //   'char': '/:8-)',
  //   'cn': '得意'
  // },

  {
    'en': 'sob',
    'char': '/::<',
    'cn': '流泪'
  },
  {
    'en': 'shy',
    'char': '/::$',
    'cn': '害羞'
  },
  // {
  //   'en': 'silent',
  //   'char': '/::X',
  //   'cn': '闭嘴'
  // },
  // {
  //   'en': 'sleep',
  //   'char': '/::Z',
  //   'cn': '睡'
  // },
  {
    'en': 'cry',
    'char': '/::\'(',
    'cn': '大哭'
  },
  {
    'en': 'awkward',
    'char': '/::-|',
    'cn': '尴尬'
  },
  // {
  //   'en': 'angry',
  //   'char': '/::@',
  //   'cn': '发怒'
  // },
  {
    'en': 'tongue',
    'char': '/::P',
    'cn': '调皮'
  },
  {
    'en': 'grin',
    'char': '/::D',
    'cn': '呲牙'
  },
  // {
  //   'en': 'surprise',
  //   'char': '/::O',
  //   'cn': '惊讶'
  // },
  {
    'en': 'frown',
    'char': '/::(',
    'cn': '难过'
  },
  {
    'en': 'ruthless',
    'char': '/::+',
    'cn': '酷'
  },
  {
    'en': 'blush',
    'char': '/:--b',
    'cn': '囧'
  },
  {
    'en': 'scream',
    'char': '/::Q',
    'cn': '抓狂'
  },
  // {
  //   'en': 'puke',
  //   'char': '/::T',
  //   'cn': '吐'
  // },
  {
    'en': 'chuckle',
    'char': '/:,@P',
    'cn': '偷笑'
  },
  {
    'en': 'joyful',
    'char': '/:,@-D',
    'cn': '愉快'
  },
  {
    'en': 'happy',
    'char': '/:happy',
    'cn': '开心'
  },

  // {
  //   'en': 'slight',
  //   'char': '/::d',
  //   'cn': '白眼'
  // },
  {
    'en': 'smug',
    'char': '/:,@o',
    'cn': '傲慢'
  },
  // {
  //   'en': 'hungry',
  //   'char': '/::g',
  //   'cn': '饥饿'
  // },
  // {
  //   'en': 'drowsy',
  //   'char': '/:|-)',
  //   'cn': '困'
  // },
  // {
  //   'en': 'panic',
  //   'char': '/::!',
  //   'cn': '惊恐'
  // },
  {
    'en': 'sweat',
    'char': '/::L',
    'cn': '流汗'
  },
  {
    'en': 'laugh',
    'char': '/::>',
    'cn': '憨笑'
  },
  {
    'en': 'commando',
    'char': '/::,@',
    'cn': '悠闲'
  },
  {
    'en': 'determined',
    'char': '/:,@f',
    'cn': '奋斗'
  },
  // {
  //   'en': 'scold',
  //   'char': '/::-S',
  //   'cn': '咒骂'
  // },
  {
    'en': 'shocked',
    'char': '/:?',
    'cn': '疑问'
  },
  {
    'en': 'shhh',
    'char': '/:,@x',
    'cn': '嘘'
  },
  {
    'en': 'dizzy',
    'char': '/:,@@',
    'cn': '晕'
  },
  {
    'en': 'tormented',
    'char': '/::8',
    'cn': '疯了'
  },
  // {
  //   'en': 'toasted',
  //   'char': '/:,@!',
  //   'cn': '衰'
  // },
  // {
  //   'en': 'skull',
  //   'char': '/:!!!',
  //   'cn': '骷髅'
  // },
  // {
  //   'en': 'hammer',
  //   'char': '/:xx',
  //   'cn': '敲打'
  // },
  {
    'en': 'wave',
    'char': '/:bye',
    'cn': '再见'
  },
  // {
  //   'en': 'speechless',
  //   'char': '/:wipe',
  //   'cn': '擦汗'
  // },
  // {
  //   'en': 'nose_pick',
  //   'char': '/:dig',
  //   'cn': '抠鼻'
  // },
  // {
  //   'en': 'clap',
  //   'char': '/:handclap',
  //   'cn': '鼓掌'
  // },
  {
    'en': 'shame',
    'char': '/:&-(',
    'cn': '糗大了'
  },
  {
    'en': 'fight',
    'char': '/:@)',
    'cn': '抱拳'
  },
  {
    'en': 'kiss',
    'char': '/::*',
    'cn': '亲亲'
  },
  // {
  //   'en': 'sly',
  //   'char': '/:X-)',
  //   'cn': '阴险'
  // },
  {
    'en': 'laughFlip',
    'char': '/:laughFlip',
    'cn': '笑翻'
  },
  {
    'en': 'whimper',
    'char': '/:8*',
    'cn': '可怜'
  },
  {
    'en': 'relieved',
    'char': '/:relieved', //
    'cn': '放松'
  },

  // {
  //   'en': 'trick',
  //   'char': '/:B-)',
  //   'cn': '坏笑'
  // },
  {
    'en': 'sun',
    'char': '/:sun',
    'cn': '太阳'
  },
  {
    'en': 'cat',
    'char': '/:cat)',
    'cn': '猫咪'
  },
  {
    'en': 'rose',
    'char': '/:rose',
    'cn': '玫瑰'
  },

  {
    'en': 'heart',
    'char': '/:heart',
    'cn': '爱心'
  },
  // {
  //   'en': 'dog',
  //   'char': '/:dog)',
  //   'cn': '狗狗'
  // },
  {
    'en': 'clap',
    'char': '/:handclap',
    'cn': '鼓掌'
  },
  {
    'en': 'shake',
    'char': '/:share',
    'cn': '握手'
  },

  {
    'en': 'party',
    'char': '/:party)',
    'cn': '庆祝'
  },
  {
    'en': 'thumbs_up',
    'char': '/:strong',
    'cn': '强'
  },

  // {
  //   'en': 'pig',
  //   'char': '/:pig',
  //   'cn': '猪头'
  // },

  {
    'en': 'popping',
    'char': '/:popping)',
    'cn': '香槟'
  },
  {
    'en': 'watermelon',
    'char': '/:<W>',
    'cn': '西瓜'
  },

  {
    'en': 'gift',
    'char': '/:gift',
    'cn': '礼物'
  },

  {
    'en': 'doughnut',
    'char': '/:doughnut', // /:doughnut
    'cn': '甜甜圈'
  }
  // {
  //   'en': 'cola',
  //   'char': '/:cola', // /:doughnut
  //   'cn': '可乐'
  // }

]
